import { createContext, useContext } from 'react';

/**
 * The first viewport that the de index page shows in the A/B test.
 * Akamai selects the group. The page component sets the value, and the
 * app provides it to the site layout and to the page.
 */
type HomeFirstViewportVariant = 'control' | 'variant';

/** A page component that sets this field changes the first viewport. */
type HasFirstViewportVariant = {
  firstViewportVariant?: HomeFirstViewportVariant;
};

const HomeFirstViewportVariantContext =
  createContext<HomeFirstViewportVariant>('control');

const useHomeFirstViewportVariant = () =>
  useContext(HomeFirstViewportVariantContext);

export { HomeFirstViewportVariantContext, useHomeFirstViewportVariant };
export type { HasFirstViewportVariant, HomeFirstViewportVariant };
